import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Card, Modal, Col, Divider, Image, Row, Table, Typography, notification, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    CheckCircleTwoTone,
    CloseCircleFilled,
    EyeFilled,
    EditFilled,
    LinkOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';

interface Props {
    location: any;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
export default function OrganizationsPage(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [deletingItem, setDeletingItem] = useState(false);
    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const columns = [
        {
            title: t('genDict.name'),
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: t('genDict.domain'),
            key: 'domain',
            dataIndex: 'domain',
            render: (a: string) => <Link href={`http://${a}`} target={'_blank'}>{a} <LinkOutlined/></Link>,
        },
        {
            title: t('organization.frontDomain.label'),
            key: 'front_domain',
            dataIndex: 'front_domain',
            render: (a: string) => <Link href={`http://${a}`} target={'_blank'}>{a} <LinkOutlined/></Link>,
        },
        {
            title: <div className={'text-center'}>{t('genDict.isClosed')}</div>,
            key: 'is_closed',
            className: 'text-center',
            dataIndex: 'is_closed',
            render: (a: number) => a ? <CheckCircleTwoTone/> : <CloseCircleFilled/>,
        },

        {
            title: t('genDict.createdAt'),
            key: 'created_at',
            dataIndex: 'created_at',
            render: (a: number) => moment(a).format(DATE_FORMAT_LONG),
        },
        // {
        //     title: <div className={'text-center'}>{t('organization.hasBBB.label')}</div>,
        //     key: 'subscription',
        //     className: 'text-center',
        //     dataIndex: 'subscription',
        //     render: (a: string) => a === 'BBB' ? <CheckCircleTwoTone/> : <CloseCircleFilled/>,
        // },
        // {
        //     title: <div className={'text-center'}>{t('organization.paypalCredentials')}</div>,
        //     key: 'paypalCredentials',
        //     className: 'text-center',
        //     render: (a: string) => <Popover content={<div>
        //         <b></b>
        //     </div>}>
        //         <Button type="primary">Hover me</Button>
        //     </Popover>,
        // },
        {
            title: t('genDict.action'),
            key: 'action',
            render: (a: any) => {
                return <Space>
                    <Button type="default" shape="circle" icon={<EyeFilled/>}
                            onClick={() => {
                                history.push(`/organizations/${a.id}/view`)
                            }}/>
                    <Button type="default" shape="circle" icon={<EditFilled/>}
                            onClick={() => {
                                history.push(`/organizations/${a.id}/edit`)
                            }}/>
                    <Button type="primary" danger={true} shape="circle" icon={<DeleteOutlined/>}
                            onClick={() => confirm({
                                icon: <ExclamationCircleOutlined/>,
                                title: t('genDict.confirmDelete'),
                                okText: t('genDict.ok'),
                                cancelText: t('genDict.cancel'),
                                content: `${t('genDict.confirmDelete')} "${a.name}"`,
                                okButtonProps: { loading: deletingItem, danger: true },
                                onOk: async () => {
                                    setDeletingItem(true);
                                    API_SERVICE.removeOrganization(a.id).then((d) => {
                                        notification.success({
                                            message: t('genDict.success'),
                                        });
                                        refreshItems();
                                    }).catch((e: any) => {
                                        notification.error({
                                            message: t(API_SERVICE.handleErrors(e)),
                                        });
                                    }).finally(() => {
                                        setDeletingItem(false);
                                    });
                                },
                            })
                            }/>
                </Space>;
            },
        },
    ];
    const refreshItems = async () => {
        try {
            setFetching(true);
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchOrganizations({ order_by: 'id', page: 1, order: 'DESC' });
            setItems(items);
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        refreshItems();
    }, []);
    return (
        <div className={'list-page-wrapper'}>
            <Row gutter={20} justify={'space-between'}>
                <Col flex={'auto'}>
                    <Title level={3}>{t('genDict.organizations')}</Title>
                </Col>
                <Col>
                    <Button type={'primary'} onClick={() => history.push('organizations/create')}>
                        {
                            t('genDict.add')
                        }
                    </Button>
                </Col>
            </Row>
            <Table loading={fetching} scroll={{ x: true }} pagination={{
                pageSize: 100,
                hideOnSinglePage: true,
            }} dataSource={items} columns={columns}/>
        </div>
    );
}
